export default function SocialProof() {
  const clients = [
    'Seminole Hard Rock',
    'SLS Brickell',
    '830 Brickell',
    'Fisher Island',
    'Yacht Club & Portofino',
    'Grove Club Miami',
  ];

  return (
    <section className="bg-[#060912] border-y border-white/5 py-8 md:py-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <p className="text-center text-gray-400 text-xs uppercase tracking-widest font-semibold mb-6">
          Trusted by South Florida&apos;s most demanding structures
        </p>
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10">
          {clients.map((c) => (
            <span
              key={c}
              className="text-white/60 font-bold text-sm md:text-base tracking-wide uppercase hover:text-white transition-colors whitespace-nowrap"
            >
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
